import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

export const useCompanyBaseInfoQuery = (domain: string, isEnabled = true) => {

    return useQuery({
        queryKey: companyAnalysisQueryKeys.companyBaseInfo(domain),
        enabled: !!domain && isEnabled,
        queryFn({ signal }) {
            return salesApiService.companyAnalysis.fetchCompanyBaseInfo(domain, {
                cancellation: signal,
            });
        },
        placeholderData: keepPreviousData,
    });
};
